import React, { Component } from 'react';
import { Message } from 'semantic-ui-react';

import Schedule from '../components/schedule';
import scheduleData from '../data/schedule';

export default class SchedulePage extends Component {
  render() {
    return (
      <div>
        <Message negative>
          <p>
            Note: The class schedule is <b>tentative</b> and subject to change! Please check the online schedule frequently.
          </p>
        </Message>
        <Schedule data={scheduleData} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/schedule-page.js